<div class="payment-popup">
  <div class="payment-popup-title">
    Prodely premium
  </div>
  <div class="payment-popup-subtitle">
    You used your AI credits.
  </div>
  <div class="payment-popup-content">
    <div class="payment-popup-content-item" (click)="purchaseCredits(100)">
      Buy 100 credits for $10
    </div>
    <div class="payment-popup-content-item" (click)="purchaseCredits(500)">
      Buy 500 credits for $45
    </div>
    <div class="payment-popup-content-item" (click)="purchaseCredits(1000)">
      Buy 1000 credits for $80
    </div>
    <div class="payment-popup-content-item" (click)="purchaseCredits(2000)">
      Buy 2000 credits for $150
    </div>
    <div class="payment-popup-content-item" (click)="purchaseCredits(5000)">
      Buy 5000 credits for $375
    </div>
  </div>
  <div class="payment-popup-close" (click)="closePaymentPopup()">
    Close
  </div>
</div>